require('./bootstrap');

let http = require('./http');
let Cookie = require("js-cookie");

export const initModalListeners = function () {

    $('#newModalWrapper').on('show.bs.modal', function (e) {

        let modal = $(this);

        $('body').addClass('modal-open');

        let element = $(e.relatedTarget);

        let data = element.data();

        let loading = '<div class="col-12 text-center mx-auto m-5"><i class="fa fa-cog fa-spin fa-3x fa-fw"></i><span class="sr-only">Loading...</span></div>';

        modal.find('.modal-body').html(loading);

        $.ajax({
            url: '/modal',
            data: data,
            type: 'GET',
            dataType: 'json',
        })
        .done(function (response) {
            if (response.status === 200) {
                modal.find('.modal-title').html(response.title);
                modal.find('.modal-body').html(response.view);
            }

            if (response.status === 422) {
                let message = document.createTextNode(response.message);
                let messageContainer = document.createElement('h6');
                messageContainer.appendChild(message);
                modal.find('.modal-body').html(messageContainer);
            }

        })
        .fail(function (error) {
            modal.modal('hide');
            console.log(error);
        })
    });

    $('#aa-shop-modal').on('show.bs.modal', function (e) {
        
        let modal = $(this);
        let element = $(e.relatedTarget);
        let data = element.data();
        let url = data.url;

        let loading = '<div class="col-12 text-center mx-auto m-5"><i class="fa fa-cog fa-spin fa-3x fa-fw"></i>Loading...</div>';

        modal.find('.modal-body').html(loading);

        $.ajax({
            url: url,
            data: data,
            type: 'GET',
            dataType: 'json',
        })
        .done(function (response) {
            if (response.status === 200) {
                modal.find('.modal-title').html(response.title);
                modal.find('.modal-body').html(response.view);
            }

            if (response.status === 422) {
                let message = document.createTextNode(response.message);
                let messageContainer = document.createElement('h6');
                messageContainer.appendChild(message);
                modal.find('.modal-body').html(messageContainer);
            }

        })
        .fail(function (error, errorText) {
            console.log(error);
            console.log(errorText);
            modal.modal('hide');
        })
    });

    $('#aa-shop-modal').on('hide.bs.modal', function (e) {
        $('.aa-shop-modal-title').html('');
    });

    $(document).on('click', '.submit-form', function (e) {

        let form = $(this).closest(':has(form)').find('form');
        
        if (form.valid()) {

            let modal = $(this).closest(':has(#newModalWrapper)').find('#newModalWrapper'),
                viewElements = {
                    'modal': modal,
                    'form': form,
                    'button': $(this),
                },
                url = form[0].action,
                data = new FormData(form[0]);

            //Disable form inputs last otherwise can't serialize form
            form.find(":input").attr('disabled', true);

            $(this).html('<i class="fa fa-cog fa-spin spinner"></i>');

            http.sendAjax(url, form[0].method, data, http.success, http.errors, viewElements);

        }
    });
}